import moment from "moment";

import * as actionTypes from "./actionTypes";

const initialState = {
  getProviderData: {},
  getTableData: {},
  getProviderDropDown: {},
  getCommonData: {},
  getDetailData: {},
  getProviderList: {},
  getNdcMainGridDetail: [],
  getProviderReviewClaimHeader: [],
  getProviderFrozenComplete: "",
  reviewCorrectionDropdown: {},
  reviewProblemDropdown: {},
  errorMessagesInRedux: {},
  getProblemCode: "",
  getCorrectionCode: "",
  getButtonState:true
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PROVIDER_DATA:
      return { ...state, getProviderData: action.payload };
    case actionTypes.SELECT_TABLE_DATA:
      return { ...state, getTableData: action.payload };
    case actionTypes.GET_PROVIDER_DROPDOWN:
      return { ...state, getProviderDropDown: action.payload };
    case actionTypes.GET_COMMON_DATA:
      return { ...state, getCommonData: action.payload };
    case actionTypes.GET_DETAIL_DATA:
      return { ...state, getDetailData: action.payload };
    case actionTypes.GET_PROVIDER_LIST:
      return { ...state, getProviderList: action.payload };
    case actionTypes.GET_NDC_GRID_DETAIL:
      return { ...state, getNdcMainGridDetail: action.payload };
    case actionTypes.GET_PROVIDER_FROZEN_COMPLETE:
      return { ...state, getProviderFrozenComplete: action.payload };
    case actionTypes.GET_PROVIDER_REVIEW_CLAIM_HEADER:
      return { ...state, getProviderReviewClaimHeader: action.payload };
    case actionTypes.GET_CORRECTION_CODE_DROPDOWN:
      return { ...state, reviewCorrectionDropdown: action.payload };
    case actionTypes.GET_PROBLEM_CODE_DROPDOWN:
      return { ...state, reviewProblemDropdown: action.payload };
    case actionTypes.GET_PROBLEMCODE:
      return { ...state, getProblemCode: action.payload };
    case actionTypes.GET_CORRECTIONCODE:
      return { ...state, getCorrectionCode: action.payload };
    case actionTypes.HANDLE_ERROR_MSG:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
      case actionTypes.BUTTON_STATE:
      return { ...state,getButtonState: action.payload };
    case actionTypes.ROW_SELECTED:
      return {
        ...state,
        rowSelected: action.rowSelected,
      };
    default:
      return state;
  }
};
export default reducer;
